export default __webpack_public_path__ + "static/media/5-4.4065012d.jpg";